/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { lottieNameToFile } from "./lottie-animation.helper";
import type { AnimationNames } from "./lottie-animation.helper";
import type { AnimationData } from "./lottie-animation.types";

export type LottieDataJson = {
	default: AnimationData;
};

export async function importLottie(lottie: AnimationNames): Promise<AnimationData | null> {
	const lottieData = await import(`./animations/${lottieNameToFile(lottie)}.json`)
		.then((module: LottieDataJson) => module.default)
		.catch((err) => {
			console.error("Error loading animation:", err);
			return null;
		});
	return lottieData;
}
